<template>
  <v-dialog
    v-model="dialogLevels"
    content-class="dialog-levels rounded-xl"
    overlay-opacity="0.1"
    max-width="500"
    transition="fade-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        v-bind="attrs"
        v-on="on"
        link
        class="rounded-xl pr-1"
        outlined
        style="height: 40px; background-color: white !important"
      >
        <v-fade-transition>
          <span class="mr-2 ml-1 secondary--text">{{ getLevel.name }}</span>
        </v-fade-transition>
        <v-img
          class="shrink rounded-circle mr-1"
          :src="getLevel.imageUrl"
          transition="fade-transition"
          height="32"
          width="32"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-icon size="20" color="white">mdi-flower-tulip-outline</v-icon>
            </v-row>
          </template>
        </v-img>
      </v-chip>
    </template>
    <v-card class="rounded-xl px-3 pt-6" style="position: relative">
      <v-btn
        icon
        class="ma-2"
        style="position: absolute; top: 0; right: 0"
        @click="dialogLevels = false"
        ><v-icon>mdi-close</v-icon></v-btn
      >
      <v-row no-gutters justify="center" class="my-2">
        <v-img
          class="shrink"
          :src="getLevel.imageUrl"
          transition="fade-transition"
          width="80"
          height="80"
          contain
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-icon size="20" color="primary"
                >mdi-flower-tulip-outline</v-icon
              >
            </v-row>
          </template>
        </v-img>
      </v-row>
      <v-row no-gutters class="text-h5 font-weight-bold" justify="center"
        ><span class="main-font secondary--text">{{
          getLevel.name
        }}</span></v-row
      >
      <v-row
        no-gutters
        justify="center"
        class="text-body-2 font-weight-bold pt-2 secondary--text"
      >
        You have collected {{ garden.numberOfFlowers || 0 }} 🍀
      </v-row>
      <v-tabs
        v-model="tab"
        active-class="selected-tab"
        hide-slider
        class="my-2"
        centered
      >
        <v-tab
          v-for="(item, index) in items"
          :key="item"
          class="text-none rounded-pill"
          style="opacity: 0.5; overflow: hidden"
        >
          <v-container>
            <v-row no-gutters class="text-h6 font-weight-light">{{
              item
            }}</v-row>
            <v-fade-transition>
              <v-row no-gutters justify="center" v-if="tab === index">
                <div class="point-tab"></div></v-row
            ></v-fade-transition>
          </v-container>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="pt-2 transparent">
        <v-tab-item>
          <v-row
            no-gutters
            justify="center"
            class="text-body-2 grey--text pb-6 pt-2"
          >
            Try to reach the maximum level
          </v-row>

          <div
            v-for="(levelFromList, index) in listOfLevels"
            :key="index"
            class="pb-6"
          >
            <v-divider class="pb-6"></v-divider>
            <v-row no-gutters>
              <v-col class="pl-3">
                <v-row no-gutters>
                  <v-col
                    cols="auto"
                    class="font-weight-bold"
                    :class="{
                      'primary--text': levelFromList.range.includes(
                        garden.numberOfFlowers
                      ),
                    }"
                    >{{ levelFromList.name }}</v-col
                  ><v-col cols="auto" align-self="center">
                    <v-row
                      no-gutters
                      justify="end"
                      class="text-caption grey--text ml-2"
                      >From {{ levelFromList.numberOfFlowers }} 🍀</v-row
                    >
                  </v-col>
                </v-row>
                <v-row no-gutters class="pt-1 text-caption secondary--text">
                  {{ levelFromList.description }}
                </v-row></v-col
              ><v-col cols="auto" align-self="center" class="px-3"
                ><v-img
                  class="shrink ml-1"
                  :src="levelFromList.imageUrl"
                  transition="fade-transition"
                  contain
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-icon size="20" color="white"
                        >mdi-flower-tulip-outline</v-icon
                      >
                    </v-row>
                  </template>
                </v-img></v-col
              >
            </v-row>
          </div>
        </v-tab-item>
        <v-tab-item>
          <v-row
            no-gutters
            justify="center"
            class="text-body-2 grey--text pb-6 pt-2 px-6"
            style="text-align: center"
          >
            Collect clovers by achieving tasks to reach the next levels
          </v-row>
          <div
            v-for="(task, index) in tasks"
            :key="index"
            class="pb-6"
            :class="{ 'grey--text': task.availableSoon }"
          >
            <v-divider class="pb-6"></v-divider>
            <v-row no-gutters>
              <v-col class="pl-3">
                <v-row no-gutters>
                  <v-col cols="auto" class="font-weight-bold">{{
                    task.name
                  }}</v-col
                  ><v-col align-self="center" cols="auto">
                    <v-row
                      no-gutters
                      justify="end"
                      class="text-caption grey--text ml-2"
                      >(+{{ task.numberOfFlowers }} 🍀)</v-row
                    >
                  </v-col>
                  <v-col
                    ><v-row no-gutters justify="end">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            color="grey"
                            v-if="task.availableSoon"
                            class="mr-3"
                            v-bind="attrs"
                            v-on="on"
                            >mdi-bullhorn-outline</v-icon
                          >
                        </template>
                        <span>Available soon</span>
                      </v-tooltip>

                      <v-icon color="primary" v-if="task.value" class="mr-3"
                        >mdi-check</v-icon
                      ></v-row
                    ></v-col
                  >
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>
 
<script>
import LIST_LEVELS from "@/fixtures/levels.json";
import { mapState } from "vuex";

export default {
  name: "DialogLevels",
  computed: {
    ...mapState("gardens", ["garden"]),
    ...mapState("self", ["self"]),
    ...mapState("plants", ["plants"]),
    ...mapState("level", ["level"]),

    getLevel() {
      if (this.garden.numberOfFlowers >= 7) return this.listOfLevels[3];
      if (this.garden.numberOfFlowers >= 5) return this.listOfLevels[2];
      if (this.garden.numberOfFlowers >= 3) return this.listOfLevels[1];
      return this.listOfLevels[0];
    },
    tasks() {
      return [
        {
          name: "Fill up a nickname",
          numberOfFlowers: 1,
          value: this.level.nickname ? true : false,
        },
        {
          name: "Add a first plant",
          numberOfFlowers: 1,
          value: this.level.plant ? true : false,
        },
        {
          name: "Add a name to a plant",
          numberOfFlowers: 1,
          value: this.level.name ? true : false,
        },
        {
          name: "Write a comment",
          numberOfFlowers: 1,
          value: this.level.comment ? true : false,
        },
        {
          name: "Add garden to the map",
          numberOfFlowers: 1,
          value: this.level.position ? true : false,
        },
        {
          name: "Add a profile picture",
          numberOfFlowers: 1,
          value: this.level.profilePictureUrl ? true : false,
        },
        {
          name: "Encourage a contributor",
          numberOfFlowers: 1,
          value: this.level.contributor ? true : false,
        },
        {
          name: "Like an idea",
          numberOfFlowers: 1,
          value: this.level.idea ? true : false,
        },
        {
          name: "Add a plant to give",
          numberOfFlowers: 1,
          value: this.level.toGive ? true : false,
        },
      ];
    },
  },
  watch: {
    dialogLevels(val) {
      if (val) {
        this.$store.dispatch(`gardens/getGarden`, this.$route.params.gardenId);
      }
    },
  },
  data() {
    return {
      dialogLevels: false,
      tab: 0,
      items: ["Levels", "Tasks"],
      listOfLevels: LIST_LEVELS,
    };
  },
};
</script>

<style>
.dialog-levels {
  border-radius: 10px !important;
}
</style>
